// The org-scoped sections BaseIndex resolves the active organization from (`/:orgId/<section>`).
const ORG_SCOPED_SECTIONS = ['space', 'inbox', 'decisions', 'all-tasks'];

/**
 * The organization app.session.started should name, or undefined while it is not settled.
 *
 * BaseIndex first sets the active organization from the stored one and only then switches to
 * the org a deep link names. On a URL that names an org, wait until the active org is that org,
 * so a cross-org deep link does not start the session in the previous org.
 */
export const sessionOrganizationId = (
  pathname: string,
  activeOrganization: { id: number; publicId: string } | undefined
): number | undefined => {
  if (!activeOrganization) return undefined;
  const [, orgSegment, section] = pathname.split('/');
  const urlNamesOrg = !!orgSegment && ORG_SCOPED_SECTIONS.includes(section);
  if (urlNamesOrg && activeOrganization.publicId !== orgSegment) return undefined;
  return activeOrganization.id;
};
